import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "py-4 text-center text-muted" }
const _hoisted_4 = {
  key: 1,
  class: "alert-badge"
}
const _hoisted_5 = {
  key: 2,
  class: "gap-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.alerts,
        "row-key": 'id',
        loading: _ctx.loading,
        pagination: _ctx.pagination,
        scroll: { x: 980 },
        class: "text-nowrap align-middle quantity-alert-table",
        onChange: _ctx.handleChange
      }, {
        emptyText: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.no_product_quantity_alerts_found`)), 1)
        ]),
        bodyCell: _withCtx(({ column, record }) => [
          (column && column.key === 'quantity')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["stock-badge", _ctx.getStockClass(record)])
              }, _toDisplayString(record.quantity), 3))
            : (column && column.key === 'stock_alert')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(record.stock_alert), 1))
              : (column && column.key === 'gap')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.getAlertGap(record)), 1))
                : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "pagination", "onChange"])
    ])
  ]))
}